// noinspection JSUnusedGlobalSymbols

import {InternalError} from './error.js'
import Helper from './helper.js'
import Is from './is.js'
import Toast from './toast.js'

export default class Ui
{
	static _indicator = null

	static indicator(on)
	{
		if(this._indicator === null)
		{
			this._indicator = document.createElement('div')
			this._indicator.className = 'loader loader-bouncing'

			document.body.appendChild(this._indicator)
		}

		if(on) $(this._indicator).addClass('is-active')
		else $(this._indicator).removeClass('is-active')
	}

	static reload(success, url, wait = 3)
	{
		if(success === false) return
		setTimeout(() => Is.filled(url) ? location.href = url : location.reload(), wait * Helper.unit.millisecond)
	}

	static post(url, data, callback = undefined, timeout_second = 10)
	{
		(async () =>
		{
			const result = {
				message: '(メッセージが指定されていません)',
				success: false,
			}

			try
			{
				const response = await $.ajax({
					method : 'POST',
					url    : url,
					data   : data,
					timeout: timeout_second * Helper.unit.millisecond,
				})

				// noinspection JSUnresolvedVariable
				result.success = response.success

				// noinspection JSUnresolvedVariable
				if(!response.success)
				{
					// noinspection JSUnresolvedVariable
					throw new InternalError(response.message || result.message)
				}

				result.message = response.message
			}
			catch(exception)
			{
				switch(exception.statusText)
				{
					case 'timeout' :
						result.message = '処理がタイムアウトしました'
					break

					default :
						result.message = exception.message || exception.statusText
						if(result.message === 'error') result.message = 'エラーが発生しました'
					break
				}

				result.success = false
			}
			finally
			{
				if(result.message !== null)
				{
					if(result.success) Toast.success(result.message)
					else Toast.warning(result.message)
				}

				if(callback !== undefined) callback(result.success, result.message)
			}
		})()
	}

	static flip(selector)
	{
		const type = $(selector).attr('type')
		$(selector).attr('type', type === 'password' ? 'text' : 'password')
	}

	static _max_mobile_width = 767

	static is_mobile()
	{
		return window.matchMedia('(max-width: 767px)').matches
	}

	static _offset = 20

	static scroll()
	{
		$('a[href^="#"]').on('click', function(event)
		{
			event.preventDefault()

			let area = document.querySelector(this.dataset.scroll)
			if(!area) area = document

			const target = area.querySelector(this.getAttribute('href'))
			target.scrollIntoView({behavior: 'smooth'})
		})

		if(location.hash.match(/^#./))
		{
			if($(location.hash).length > 0)
			{
				$('html, body').animate({scrollTop: $(location.hash).offset().top - this._offset}, 'fast')
			}
		}
	}
}
